<mat-card class="mb-4">
  <div class="title-bar">
    <h2 class="mb-3">{{ "VIP_DISCOUNTS.PARTNERS.TITLE" | translate }}</h2>
  </div>
  <button
    type="button"
    mat-raised-button
    color="primary"
    (click)="openPartnerSelector()"
  >
    <mat-icon>search</mat-icon>
    {{ "VIP_DISCOUNTS.PARTNERS.SEARCH_TEXT" | translate }}
  </button>

  <div class="table-container">
    <table
      class="data-table mt-4"
      mat-table
      [dataSource]="partnersTableDataSource"
      matSort
      #partnersTable
    >
      <app-checkable-column
        [hideCheckboxInHeader]="true"
        [tableRef]="partnersTable"
      >
      </app-checkable-column>

      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "VIP_DISCOUNTS.PARTNERS.TABLE.COMPANY_NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.companyName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="brandName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "VIP_DISCOUNTS.PARTNERS.TABLE.BRAND_NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.brandName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            mat-icon-button
            (click)="deselectPartner(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let idx = index; columns: displayedColumns"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          {{ "VIP_DISCOUNTS.PARTNERS.TABLE_EMPTY" | translate }}
        </td>
      </tr>
    </table>
  </div>
</mat-card>
